import React from "react";
import { Link } from "react-router-dom";
import { Eyebrow } from "../components/Primitives";
import AppShell from "../components/AppShell";

export default function Terms() {
    return (
        <AppShell>
            <div className="flex-1 flex flex-col bg-cream" data-testid="terms-screen">
                <div className="px-6 pt-6 pb-3 flex items-center justify-between border-b border-burgundy/10">
                    <Link to="/" data-testid="terms-back-link" className="tap-target text-[11px] tracking-[0.28em] uppercase text-ink-muted hover:text-burgundy">
                        ← Back
                    </Link>
                    <span className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Legal</span>
                    <span className="w-8" />
                </div>

                <article className="flex-1 overflow-y-auto px-7 py-8 max-w-2xl mx-auto w-full">
                    <Eyebrow>Beta program</Eyebrow>
                    <h1 className="mt-2 font-display text-4xl text-burgundy leading-[1.1]">
                        <span className="italic">Terms &amp;</span> conditions
                    </h1>
                    <p className="mt-3 text-[10px] tracking-[0.32em] uppercase text-ink-light" data-testid="terms-updated">
                        Last updated · February 2026
                    </p>

                    <section className="mt-8 space-y-7 text-sm text-ink leading-relaxed">

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">1. Acceptance of these terms</h2>
                            <p className="mt-3">
                                By creating an account, completing your profile, or joining the Ever After beta, you agree to be bound by these Terms &amp; Conditions and our {" "}
                                <Link to="/privacy" className="text-burgundy underline underline-offset-4">Privacy Policy</Link>. If you do not agree, please do not use the service.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">2. Beta service</h2>
                            <p className="mt-3">
                                Ever After is currently offered as a closed beta. Features may change, break, or be removed without notice. Your feedback is welcome at <a href="mailto:info@youreverafter.com" className="text-burgundy underline underline-offset-4">info@youreverafter.com</a>.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">3. Eligibility</h2>
                            <p className="mt-3">
                                You must be at least 21 years old to use Ever After. By using the service you represent that you are single or otherwise free to pursue romantic relationships, and that all information you provide is accurate.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">4. Honest profile</h2>
                            <p className="mt-3">
                                You agree to provide truthful, current information in your profile, photos, and assessment answers. Misrepresentation, harassment, fraud, or use of the platform for commercial solicitation may result in immediate termination of your account and forfeiture of any paid balances.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">5. Founding Member credit</h2>
                            <p className="mt-3">
                                The $99 Founding Member contribution is a prepaid credit applied to your account. Your credit applies to any paid Ever After plan when we officially launch. Credit does not expire. The Founding 100 spots are limited to 100 members, claimed in order. Refunds are available within 30 days of purchase, no questions asked, by contacting <a href="mailto:info@youreverafter.com" className="text-burgundy underline underline-offset-4">info@youreverafter.com</a>.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">6. AI features</h2>
                            <p className="mt-3">
                                Ever After uses artificial intelligence to provide personality insights, match curation, and conversational coaching. AI advice is for informational and supportive purposes only and is not a substitute for licensed therapy, medical, legal, or financial advice. If you are in crisis, contact the 988 Suicide &amp; Crisis Lifeline or your local emergency services.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">7. Your content</h2>
                            <p className="mt-3">
                                You retain ownership of the photos, videos, and text you submit. By submitting content you grant Ever After a non-exclusive, royalty-free license to host, display, and process it solely for the purpose of operating the service (including showing your profile to other members and improving our matching algorithms).
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">8. Privacy &amp; data</h2>
                            <p className="mt-3">
                                Our handling of your personal data is governed by our <Link to="/privacy" className="text-burgundy underline underline-offset-4">Privacy Policy</Link>, which forms part of these Terms.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">9. Termination</h2>
                            <p className="mt-3">
                                You can delete your account at any time. We may suspend or terminate accounts that violate these Terms, attempt to defraud the platform, or harm other members.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">10. Disclaimers &amp; liability</h2>
                            <p className="mt-3">
                                The service is provided "as is" during beta. To the maximum extent permitted by law, Ever After disclaims all warranties and limits its aggregate liability to the amount you have paid in the prior 12 months.
                            </p>
                        </div>

                        <div>
                            <h2 className="font-display italic text-2xl text-burgundy">11. Changes</h2>
                            <p className="mt-3">
                                We may update these Terms as the service evolves. Material changes will be communicated by email. Continued use after a change means you accept the revised Terms.
                            </p>
                        </div>

                        <div className="mt-6 p-5 bg-cream-soft border border-burgundy/15">
                            <p className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Contact</p>
                            <p className="mt-2 text-sm text-ink">
                                Questions about these terms? Email{" "}
                                <a
                                    data-testid="terms-contact-email"
                                    href="mailto:info@youreverafter.com"
                                    className="text-burgundy underline underline-offset-4"
                                >
                                    info@youreverafter.com
                                </a>.
                            </p>
                        </div>
                    </section>

                    <footer className="mt-12 pt-6 border-t border-burgundy/15 text-center text-[10px] tracking-[0.32em] uppercase text-ink-light">
                        <Link to="/" className="hover:text-burgundy" data-testid="terms-home-link">
                            Ever After · youreverafter.com
                        </Link>
                    </footer>
                </article>
            </div>
        </AppShell>
    );
}
